import { Helmet } from "react-helmet";
import CaseStudiesBody from "../components/case-studies/CaseStudiesBody";
import SolutionsNtunaCTAWorld from "../components/solutions/SolutionsNtunaCTAWorld";

export default function CaseStudies() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/case-studies"
        />
        <meta
          name="description"
          content="Explore NTUNA.COM's case studies to discover our web and ICT solutions real-world impact across different industries and sectors."
        />
       
        <meta
          property="og:description"
          content="Explore NTUNA.COM's case studies to discover our web and ICT solutions real-world impact across different industries and sectors."
        />
        <meta property="og:title" content="NTUNA.COM | Case Studies" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta name="twitter:title" content="NTUNA.COM | Case Studies" />
        <meta name="twitter:text:title" content="NTUNA.COM | Case Studies" />
        <meta
          name="twitter:description"
          content="Explore NTUNA.COM's case studies to discover our web and ICT solutions real-world impact across different industries and sectors."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM | Case Studies</title>
      </Helmet>

      <CaseStudiesBody />
      <SolutionsNtunaCTAWorld />
    </>
  );
}
